import React from 'react';
import {ThemeProvider, injectGlobal} from 'styled-components';

class StyledBase extends React.Component {
  constructor(props) {
    super(props);

    this.theme = {
      radius: {
        general_ui: '6px',
      },
      colors: {
        brand: '#E2484D',
        brand_dark: '#BE262A',
        dark: '#122535',
        dark_dark: '#0b1925',
        disabled_input: '#AAA',
        text: '#4A5158',
        border: '#E9E9E9',
        background: '#F8F8F8',
        fade: 'rgba(37, 25, 39, 0.84)',
        shadow: '0 3px 4px rgba(49, 19, 37, 0.84)',
        yellow: ['', '#C98E00', '#FFB400'],
        green: ['', '#319C2C', '#51C24C'],
        blue: ['', '#2A64AC', '#4886D3'],
        red: ['', '#BE262A', '#E2484D'],
      },
    };

    injectGlobal`
            html, body, div, span, applet, object, iframe,
            h1, h2, h3, h4, h5, h6, p, blockquote, pre,
            a, abbr, acronym, address, big, cite, code,
            del, dfn, em, img, ins, kbd, q, s, samp,
            small, strike, strong, sub, sup, tt, var,
            b, u, i, center,
            dl, dt, dd, ol, ul, li,
            fieldset, form, label, legend,
            table, caption, tbody, tfoot, thead, tr, th, td,
            article, aside, canvas, details, embed,
            figure, figcaption, footer, header, hgroup,
            menu, nav, output, ruby, section, summary,
            time, mark, audio, video {
                margin: 0;
                padding: 0;
                border: 0;
                font-size: 100%;
                font: inherit;
                vertical-align: baseline;
            }
            /* HTML5 display-role reset for older browsers */
            article, aside, details, figcaption, figure,
            footer, header, hgroup, menu, nav, section {
                display: block;
            }
            body {
                line-height: 1;
            }
            ol, ul {
                list-style: none;
            }
            blockquote:before, blockquote:after,
            q:before, q:after {
                content: '';
                content: none;
            }
            table {
                border-collapse: collapse;
                border-spacing: 0;
            }
            a {
                color: inherit;
                text-decoration: none;
                &:VISITED{
                    color: inherit;
                }
            }
            html{
                padding: 0;
                margin: 0;
            }

            body {
                background-color: ${this.theme.colors.background};
                color: ${this.theme.colors.text};
                margin: 0;
                font-family: sans-serif;
            }
            * {
                box-sizing: border-box;
            }
            input{
                &:FOCUS{
                    outline: none;
                }
            }
        `;
  }

  render() {
    return (
      <ThemeProvider theme={this.theme}>{this.props.children}</ThemeProvider>
    );
  }
}

export default StyledBase;



// WEBPACK FOOTER //
// ./src/components/base/StyledBase.js